export const tr = {
    'check-phrases-and-groups-settings': 'Anahtar sözcük gruplarını ve grup ayarlarını kontrol edin.',
    'check-show-conditions':
        'Yeniden pazarlama ve hedef kitle seçim koşullarını değiştirin, anahtar sözcük gruplarını operatörlerle kısıtlamayın, anahtar sözcük grubu listesini bölgenizdeki taleplere göre düzenleyin, ağlarda gösterimler için teklifi arttırın. Bu sayede, reklamlarınız açık artırmayı daha sık kazanır.',
    'many-group-title': 'Adjust {count} groups with low estimated impressions',
    'one-group-title': 'Correct {count} group with low estimated impressions',
    'one-group-title-hint': 'Öneri, grubun gösterim sayısının az olacağı tahmin edildiği için gösterilmektedir',
    'several-group-title-hint':
        'Öneri, bazı grupların gösterim sayısının az olacağı tahmin edildiği için gösterilmektedir',
    'show-many-group-button': '{count} grubu göster',
    'show-one-group-button': '{count} grubu göster',
    'show-some-group-button': '{count} grubu göster',
    'simple-title': "The group's ads are not served or are rarely served. Try adjusting settings.",
    'some-group-title': 'Adjust {count} groups with low estimated impressions',
    'twenty-one-group-title': 'Adjust {count} group with low estimated impressions'
};
